
export class RegistroAgenda{
    title: string;
    date: Date;
    hours:Date; 
    id:string;
    link:string;
}